<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/Page-header";
import Style from "@/views/layouts/style";

export default {
    components: {
        Layout,
        PageHeader,
        Style,
    },
    data() {
        return {
            title: "Manual de usuario",
            loading: true,
            mostrarPDF: false,
            companies_id: this.$store.getters["company/getCompany"].id || null,

        };
    },
    methods: {
        async print() {
        try {
            const url = 'https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/sst-prod/estandares/Manual_de_usuario_SST.pdf';
            const response = await fetch(url);
            const blob = await response.blob();
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', 'Manual_de_usuario_SST.pdf'); // Nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.log(error);
        }
    },
        showPDF() {
            this.mostrarPDF = !this.mostrarPDF;
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" />
        <div class="row animated animatedFadeInUp fadeInUp">
            <div class="col-md-12">
                <div class="col-xl-12">

                    <div class="row">
                        <div class="col-12">
                            <div class="card">

                                <div class="row">
                                    <div class="card-body">

                                        <div class="col-12 content_btns">
                                            <label class="titulo" for=""><strong>DESCARGAR MANUAL DE USUARIO</strong></label>
                                            <br>
                                            <button @click="print" class="btn btn-primary">Descargar</button>
                                            <button @click="showPDF" 
                                                :class="{'btn btn-primary': !mostrarPDF, 'btn btn-danger': mostrarPDF}">
                                                {{ mostrarPDF ? 'Cancelar' : 'Ver en linea' }}
                                            </button>
                                        </div>
                                        <br>
                                        <div class="col-12" v-if="mostrarPDF">
                                            <!-- Visor de PDF -->
                                            <iframe class="visor" src="https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/sst-prod/estandares/Manual_de_usuario_SST.pdf#toolbar=0"> </iframe>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </Layout>
</template>
<style>
.content_btns {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.titulo {
    font-size: 1.8rem;
}

.visor{
    width: 100%;
    height: 100vh;
    border: none;
}
</style>